import Vue from 'vue'

import fgInput from './components/UIComponents/Inputs/formGroupInput'
import DropDown from './components/UIComponents/Dropdown'
import IEcharts from 'vue-echarts-v3/dist/VueECharts'
import SisSelect from 'components/UIComponents/Inputs/SisSelect'

function globalNotify (type, text, time = 3000) {
  Vue.prototype.$notifications.notify({
    message: text,
    icon: 'mdi mdi-alert-circle',
    horizontalAlign: 'center',
    verticalAlign: 'top',
    type: type,
    timeout: time
  })
}

function getConvertDate (time, options = null) {
  if (time === 0) return ''
  let date = new Date(time * 1000)
  if (!options) {
    options = {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }
  }else{
    if (options.timeZone === '' || options.timeZone === 'Local Time') {
      delete(options.timeZone)
    }
  }
  return date.toLocaleString(navigator.language, options)
}

function copyToClipboard(textToCopy) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(textToCopy);
  } else {
    // text area method
    let textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((res, rej) => {
      document.execCommand('copy') ? res() : rej();
      textArea.remove();
    });
  }
}

function badAnswerHandler(bad_answer) {
  let text = bad_answer.data.error.name
  if (typeof(bad_answer.data.error.message) === 'string'){
    text += '<br>' + bad_answer.data.error.message
  }else if(typeof(bad_answer.data.error.message) === 'object'){
    for (let key in bad_answer.data.error.message) {
      text += '<br>' + key + ': ' + bad_answer.data.error.message[key][0]
    }
  }

  Vue.prototype.$notifications.notify({
    message: text,
    icon: 'mdi mdi-alert-circle',
    horizontalAlign: 'center',
    verticalAlign: 'top',
    type: 'danger',
    timeout: 5000
  })
}


const Global = {
  install (Vue) {
    Vue.component('fg-input', fgInput)
    Vue.component('drop-down', DropDown)
    Vue.component('sis-select', SisSelect)
    Vue.component('IEcharts', IEcharts)
    Vue.prototype.get_date = (time, options) => getConvertDate(time, options)
    Vue.prototype.copy_to_clipboard = (param) => copyToClipboard(param)
    Vue.prototype.global_notify = (type, text, time) => globalNotify(type, text, time)
    Vue.prototype.bad_answer_handler = (answer) => badAnswerHandler(answer)
  }
}

export default Global
